module.exports = __webpack_public_path__ + "fonts/Manrope-400-vietnamese4.d255f9e.woff2";